<template>
  <div class="modalDuplicate">
    <div style="border-radius:10px;padding:10px;" class="card">
      <img
        @click="closeModalDuplicate()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <p>{{ $t("evenement.duplicate") }}</p>
      <hr />
      <Duplicate outil="eventify" :row="modalDuplicate.evenement" />
    </div>
  </div>
</template>

<script>
import Duplicate from "@/components/event/components/Duplicate";
export default {
  name: "ModalDuplicate",
  components: {
    Duplicate
  },
  props: {
    modalDuplicate: Object
  },
  methods: {
    closeModalDuplicate() {
      this.$store.commit("MODAL_DUPLICATE", {
        evenement: null,
        activeModalDuplicate: false
      });
    }
  }
};
</script>
<style scoped>
.modalDuplicate {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/ModalDuplicate.vue